<template>
  <div>
    <alert-message-modal></alert-message-modal>
    <div class="container">
      <div class="col-12">
        <div class="col-12 col-md-12 col-xl-12">
          <div class="block-header bg-primary">
            <h1 class="flex-sm-fill h3 my-2 text-white">
              <i class="fa fa-cogs text-white"></i> Settings
              <small class="d-block d-sm-inline-block mt-2 mt-sm-0 font-size-base font-w400 text-white">
              Edit all the details here!
              </small>
            </h1>
          </div>
          <div class="block-content block-content-full">
            <div class="row">
              <div class="form-group col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
                <div class="font-s20 font-w600">
                  Default facility
                </div>
                <div class="font-w400 text-muted setting-hint">
                  You can change your default facility here.
                </div>
              </div>
              <div class="form-group text-right col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <select class="form-control form-control-alt" v-model="defaultFacility">
                  <option v-for="(facility, index) in facilities" :key="index" :value="facility.id" :selected="facility.isDefault == 1">{{ facility.businessName }}</option>
                </select>
              </div>
            </div>
            <hr />
            <div class="block-content block-content-full text-right button-loader">
              <button type="button" class="btn btn-sm btn-light" @click.prevent="$router.go(-1)">Cancel</button>
              <button type="button" class="btn btn-sm btn-primary" @click='update()' title="Click to save changes" :disabled="showButtonLoader">
                <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
                <span class="modal-loader" v-if="showButtonLoader">
                  <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import AlertMessageModal from '@/components/AlertMessageModal';
import { helper } from '@/helper.js';
import base64 from 'base-64';
import utf8 from 'utf8';
Vue.use(VueSpinners, base64, utf8);

export default {
  name: 'Settings',
  data() {
    return {
      facilities: [],
      defaultFacility: null,
      email: utf8.decode(base64.decode(localStorage.token)),
      showButtonLoader: false,
      currentId: null
    };
  },
  created() {
    let vm = this;
    helper.sendPostRequest('/user/get', {'email': vm.email})
      .then((data) => {
        if (data.status === 'success') {
          vm.facilities = data.data.facility;
          for(var i in vm.facilities ) {
            if (vm.facilities[i].isDefault == 1) {
              vm.defaultFacility = vm.facilities[i]['id'];
              vm.currentId = vm.facilities[i]['id'];
            }
          }
        }
      }).catch(function() {
        vm.error('Unable to process your request, Please try again later.');
        this.triggerMessageModal('#alert_modal');
      });
  },
  components: {
    AlertMessageModal,
    HashLoader
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['clearData']),
    update() {
      let vm = this;
      vm.showButtonLoader = true;
      helper.sendPostRequest('/settings/update', {
        'email': vm.email,
        'defaultFacility': vm.defaultFacility
      }).then((data) => {
        if (data.status === 'success') {
          vm.success(data.message);
          if (vm.currentId !== vm.defaultFacility) {
            vm.clearData();
            helper.loadSiteData();
            vm.currentId = vm.defaultFacility;
          }
        } else {
          vm.error(data.message);
        }
        vm.showButtonLoader = false;
        this.triggerMessageModal('#alert_modal');
      }).catch(function() {
        vm.error('Unable to process your request, Please try again later.');
        this.triggerMessageModal('#alert_modal');
      });
    }
  }
};
</script>
<style scoped>
.setting-hint {
  font-size: 12px;
}
.block-content {
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// source/components/Settings.vue